export enum ExportType {
	STATIC = 'static',
	VIDEO = 'video',
	HTML5 = 'html5',
	AUDIO = 'audio',
	PRINT = 'print',
	EMAIL = 'email',
	// Value must match the encoder's AdBuilderFormat.AnimatedGif exactly;
	// the encoder matches `formats` by string.
	ANIMATED_GIF = 'animatedGif'
}
